import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Paragraph from '@sv-support-sdk/ui-components/src/components/Typography/Paragraph';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import PageContentInner from '../../components/Layout/Page/PageContentInner';
import CategoryBlock from '../../components/Pages/HelpCenterCategory/CategoryBlock';
import SingleCategoryBlock from '../../components/Pages/HelpCenterCategory/SingleCategoryBlock';
import Breadcrumbs from '../../components/Navigation/Breadcrumbs';
import LoaderFallback from '../../components/Feedback/Loader/LoaderFallback';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { grandCategoryBySlugSelector, selectLoading } from '../../store/selectors/helpCenter';
import helpCenterActions from '../../store/actions/helpCenter';
import { $l } from '../../locales';
import { routes } from '../../routing';
import {
  BREADCRUMBS_CATEGORY,
  SUPPORT_HELP_CENTER_CATEGORY_NAME,
} from '../../constants/qaAttributes';
import setQaAttribute from '../../helpers/setQaAttribute';

const HelpCenterCategory = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectLoading);
  const grandCategory = useAppSelector((state) =>
    grandCategoryBySlugSelector(state, params.category),
  );

  useEffect(() => {
    dispatch(helpCenterActions.getCategories());
    dispatch(
      helpCenterActions.getTopics({
        noteTitle: $l('HELP_CENTER_TOPIC.NOTE'),
        tipTitle: $l('HELP_CENTER_TOPIC.TIP'),
      }),
    );
  }, [dispatch]);

  if (loading.categories || loading.topics) {
    return (
      <PageContentInner height="full">
        <LoaderFallback />
      </PageContentInner>
    );
  }

  if (!grandCategory) {
    return <SingleCategoryBlock />;
  }

  return (
    <PageContentInner>
      <Breadcrumbs
        items={[
          { text: $l('BREADCRUMBS.GUIDES'), link: routes.articles },
          { text: grandCategory.name, isLast: true },
        ]}
        className="indent-md-bottom"
        qaId={BREADCRUMBS_CATEGORY}
      />
      <Headline className="indent-sm-bottom" {...setQaAttribute(SUPPORT_HELP_CENTER_CATEGORY_NAME)}>
        {grandCategory.name}
      </Headline>
      <Paragraph>{grandCategory.description}</Paragraph>
      <CategoryBlock grandCategory={grandCategory} />
    </PageContentInner>
  );
};

export default HelpCenterCategory;
